import React from 'react';
import Typography from '@mui/material/Typography';
import { datasetExists } from 'components/CleanRooms/AllQuestions/utils';
import { styled } from '@mui/material/styles';


const StyledTypography = styled(Typography, {
  shouldForwardProp: (props) => props !== 'noDatasets',
})(({ noDatasets }) => ({
  ...(noDatasets ? { color: 'rgba(0,0,0,0.3)' } : {}),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const DataTypes = ({ details }) => {
  const { dataTypes } = details;

  const formattedDataTypes = dataTypes
    .filter(datasetExists)
    .map((d) => d.displayName)
    .join(', ');

  return (
    <StyledTypography
      variant='body2'
      noDatasets={!formattedDataTypes}
    >
      {formattedDataTypes || 'No datasets available'}
    </StyledTypography>
  );
};
